import { Link, useLocation } from "react-router-dom";
import { Home, Dumbbell, Activity, User } from "lucide-react";

const tabs = [
  { to: "/dashboard", label: "Home", icon: Home, testid: "tab-home" },
  { to: "/exercises", label: "Exercises", icon: Dumbbell, testid: "tab-exercises" },
  { to: "/progress", label: "Progress", icon: Activity, testid: "tab-progress" },
  { to: "/profile", label: "Me", icon: User, testid: "tab-profile" },
];

export default function BottomNav() {
  const { pathname } = useLocation();
  return (
    <nav
      data-testid="bottom-nav"
      className="fixed bottom-0 left-1/2 -translate-x-1/2 w-full max-w-md bg-white/95 backdrop-blur border-t border-slate-200 z-30"
    >
      <ul className="grid grid-cols-4">
        {tabs.map((t) => {
          const active = pathname.startsWith(t.to);
          const Icon = t.icon;
          return (
            <li key={t.to}>
              <Link
                to={t.to}
                data-testid={t.testid}
                className={`flex flex-col items-center justify-center gap-1 py-3 text-xs ${
                  active ? "text-teal-600" : "text-slate-500"
                }`}
              >
                <Icon size={20} strokeWidth={active ? 2.5 : 2} />
                <span className="font-medium">{t.label}</span>
              </Link>
            </li>
          );
        })}
      </ul>
    </nav>
  );
}
